import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=0aac888b&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=0aac888b&prod&lang=scss&scoped=true"
import style1 from "./CustomTable.vue?vue&type=style&index=1&id=0aac888b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac888b",
  null
  
)

export default component.exports